import React from 'react';
import DOMPurify from 'dompurify';

let sanitize = (html) => html;
try {
  const DOMPurify = require('dompurify');
  const decode = (s) => s;

  // Add a hook so links open safely in new tab
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  sanitize = (html) =>
    DOMPurify.sanitize(decode(html), {
      ALLOWED_TAGS: [
        'p', 'a', 'strong', 'em', 'u', 's', 'br', 'hr',
      'ul', 'ol', 'li', 'blockquote', 'pre', 'code',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'img', 'figure', 'figcaption', 'span', 'div'
      ],
      ALLOWED_ATTR: [
        'href', 'target', 'rel', 'title',
      'src', 'srcset', 'sizes', 'alt', 'width', 'height',
      'class', 'style'
      ],
      FORBID_TAGS: ['script','iframe'],
      FORBID_ATTR: ['onerror','onclick','onload']
    });
} catch (_) {}

export default function RichHTML({ html, className = '' }) {
  const clean = sanitize(html || '');
  return (
    <article
      className={`prose lg:prose-lg max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}